export default "__VITE_ASSET__e40eb5dc__"